"use client";

import React, { useEffect, useState } from "react";
import styles from "./STHeader.module.css";
import Link from "next/link";
import Image from "next/image";
import { Logo } from "@/assets/images";
import { navItems } from "@/const/data";
import { getLenis, STButton } from "..";
import { getPagesList } from "@/actions";
import clsx from "clsx";
import { useRouter } from "next/router";
import { Icons } from "@/const/icons";

export const STHeader = () => {
  const router = useRouter();
  const { pathname } = router;
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dynamicNavItems, setDynamicNavItems] = useState(navItems);

  useEffect(() => {
    getPagesList()
      .then((res) => {
        const list = res?.data?.pageList || (Array.isArray(res?.data) ? res.data : []);
        const nonTechSlugs = new Set([
          "home",
          "our-technology",
          "about",
          "about-us",
          "blog",
          "blogs",
          "our-partners",
          "partners",
          "contact",
          "contact-us",
          "underconstruction",
          "under-construction",
          "career",
          "news-blogs",
          "news-feed",
          "privacy-policy",
          "terms",
          "test",
        ]);
        const techPages = list.filter(
          (p) => p.slug && !nonTechSlugs.has(p.slug.toLowerCase())
        );
        if (techPages.length > 0) {
          setDynamicNavItems((prev) =>
            prev.map((nav) => {
              if (nav.label === "Our technology" && nav.children) {
                const existingSlugs = new Set(nav.children.map((c) => c.href));
                const newChildren = [...nav.children];
                techPages.forEach((tp) => {
                  const href = `/our-technology/${tp.slug}`;
                  if (!existingSlugs.has(href)) {
                    newChildren.push({
                      label: tp.name || tp.title || tp.slug,
                      href,
                    });
                  }
                });
                return { ...nav, children: newChildren };
              }
              return nav;
            })
          );
        }
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    const lenis = getLenis();

    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      lenis?.stop();
    } else {
      document.body.style.overflow = "auto";
      lenis?.start();
    }
  }, [isMenuOpen]);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={clsx(
        styles.header,
        scrolled && styles.scrolled,
        "d-flex align-items-center position-fixed w-100 start-0 top-0",
      )}
    >
      <div className="container">
        <div className="d-flex align-items-center justify-content-between">
          <Link href="/" className={clsx(styles.logo, "rounded-circle  ")}>
            <Image src={Logo} alt="Sustanix Logo" width={48} height={48} />
          </Link>

          {isMenuOpen && (
            <div
              className={styles.overlay}
              onClick={() => setIsMenuOpen(false)}
            />
          )}
          <nav>
            <ul
              className={clsx(
                styles.navList,
                isMenuOpen && styles.open,
                "d-flex flex-column flex-xl-row align-items-end align-items-xl-center justify-content-center",
              )}
            >
              {isMenuOpen && (
                <li>
                  <button
                    className={clsx(styles.closeBtn)}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                  >
                    {Icons.closeIcon}
                  </button>
                </li>
              )}
              {dynamicNavItems.map((item, index) => {
                const isActive =
                  pathname === item.href ||
                  (pathname && pathname.startsWith(item.href + "/"));

                return (
                  <li
                    key={index}
                    className={clsx(styles.navItem, "position-relative")}
                  >
                    <div
                      className={clsx(
                        styles.navLinkWrapper,
                        "d-flex align-items-center",
                      )}
                    >
                      <Link
                        href={item.href}
                        onClick={() => setIsMenuOpen(false)}
                        className={clsx(
                          styles.navLink,
                          isActive && styles.active,
                          "p mb-0 fw-normal position-relative text-math-auto",
                        )}
                      >
                        {item.label}
                      </Link>

                      {item.children && (
                        <span
                          className={clsx(
                            styles.dropdownIcon,
                            "d-flex cursor-pointer transition-smooth",
                          )}
                        >
                          {Icons.arrowDown}
                        </span>
                      )}
                    </div>

                    {item.children && (
                      <ul className={styles.dropdown}>
                        {item.children.map((child, i) => (
                          <li key={i}>
                            <Link
                              href={child.href}
                              className={clsx(styles.dropdownLink, "p")}
                              onClick={() => setIsMenuOpen(false)}
                            >
                              {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
              <li>
                <STButton
                  variant="white"
                  className={"d-sm-none"}
                  onClick={() => {
                    router.push("/contact-us");
                    setIsMenuOpen(false);
                  }}
                >
                  Let’s connect
                </STButton>
              </li>
            </ul>
          </nav>

          <div className="d-flex align-items-center gap-xs">
            <STButton
              variant="white"
              className={clsx(styles.letsConnectBtn, "d-none d-sm-flex")}
              onClick={() => router.push("/contact-us")}
            >
              Let’s connect
            </STButton>
            {/* OPEN NEW TAB  button click event per */}
            <STButton
              onClick={() =>
                window.open(
                  "https://calendar.app.google/kUFBWctjif4ddEC6A",
                  "_blank",
                )
              }
            >
              Book a demo
            </STButton>
            <button
              className={clsx(
                styles.hamburger,
                "d-xl-none",
                isMenuOpen && styles.active,
              )}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Menu Toggle"
            >
              {Icons.menuIcon}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

